import { render, staticRenderFns } from "./SellerPaymentIndex.vue?vue&type=template&id=3f4382b4"
import script from "./SellerPaymentIndex.vue?vue&type=script&lang=js"
export * from "./SellerPaymentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports